import { useMutation } from '@tanstack/react-query';

import { endpoints } from '@/react-query/endpoints';

import { HUBSPOT_FORM_ID, HUBSPOT_PORTAL_ID } from '../constants';
import type { PreQualifyFormValues } from '../types';

interface SubmitParams {
  dealId: string;
  values: PreQualifyFormValues;
  qualifierLink?: string;
}

export const useSubmitToHubSpot = () => {
  return useMutation({
    mutationFn: async ({ dealId, values, qualifierLink }: SubmitParams) => {
      const response = await fetch(
        endpoints.hubspot.formSubmit(HUBSPOT_PORTAL_ID, HUBSPOT_FORM_ID),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            fields: [
              { name: 'firstname', value: values.firstName },
              { name: 'lastname', value: values.lastName },
              { name: 'email', value: values.email },
              { name: 'mobilephone', value: values.phone },
              { name: 'company', value: values.companyName },
              {
                name: 'product_request_qualifier_form',
                value: values.productRequest,
              },
              { name: 'primary_pms', value: values.primaryPms },
              { name: 'imaging_platform', value: values.imagingPlatform },
              { name: 'it_contact_email', value: values.itContactEmail },
              { name: 'deal_id', value: dealId },
              { name: 'qualifier_link', value: qualifierLink ?? '' },
            ],
            context: {
              pageUri: window.location.href,
              pageName: 'Tech Validation',
            },
          }),
        },
      );

      if (!response.ok) {
        const errorBody = await response.text();
        throw new Error(`HubSpot submission failed: ${errorBody}`);
      }

      return response.json();
    },
  });
};
